export enum MarketplaceCartScopeValues {
  Shop = 'SHOP',
  Marketplace = 'MARKETPLACE',
}

export enum MarketplaceCapabilitiesTypeValues {
  DigitalMenu = 'DIGITAL_MENU',
}
